import { jsxs, jsx } from 'react/jsx-runtime';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';

var details = "Details-module_details__ku9E3";
var icon = "Details-module_icon__PQt4g";
var body = "Details-module_body__F8FJc";

const Details = ({ summary, children, className, noPadding = false, ...rest }) => {
    return (jsxs("details", { className: classNames(details, className), ...rest, children: [jsxs("summary", { children: [jsx(FontAwesomeIcon, { icon: faChevronDown, className: icon }), summary] }), jsx("div", { className: classNames(!noPadding && body), children: children })] }));
};

export { Details };
